import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import Cropper from "cropperjs";

let cropper;
const CropperTest = ({ setImageCroppedToPreviewImageArea }) => {
  let uploadImageAdvertiseNativeButton;
  let btnCrop;
  let croppable = false;
  let image;
  let cropBoxData;
  let canvasData;

  const [show, setShow] = useState(false);
  const [imageTag, setImageTag] = useState();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    uploadImageAdvertiseNativeButton = document.querySelector(
      "#upload-image-advertise-native-button"
    );
    btnCrop = document.querySelector("#btn-crop");
  });

  const changeHandler = (e) => {
    let files = e.target.files;

    handleShow();

    let fileReader = new FileReader();
    let file;

    if (files && files.length > 0) {
      file = files[0];

      fileReader.onload = function (e) {
        done(fileReader.result);
      };
      fileReader.readAsDataURL(file);
    }
  };

  const done = (url) => {
    setImageTag(
      <>
        <img id="image" src={url} />
        <div className="text-center pt-2">
          <span className="btn btn-primary ml-1" id="zoom-in-btn">
            <i
              class="fa fa-search-plus"
              onClick={() => {
                document.querySelector("#zoom-in-btn").click();
              }}
            ></i>
          </span>
          <span className="btn btn-danger mr-1" id="zoom-out-btn">
            <i
              class="fa fa-search-minus"
              onClick={() => {
                document.querySelector("#zoom-out-btn").click();
              }}
            ></i>
          </span>
        </div>
      </>
    );

    image = document.querySelector("#image");
    initCropper(image, cropBoxData, canvasData);
  };

  const initCropper = (image, cropBoxData, canvasData) => {
    let options = {
      aspectRatio: 1.5,
      viewMode: 1,
      ready: function () {
        croppable = true;
        cropper.setCropBoxData(cropBoxData).setCanvasData(canvasData);
      },
      zoom: function (e) {
        if (e.target.id === "zoom-in-btn") {
          cropper.zoom(0.1);
        }
        if (e.target.id === "zoom-out-btn") {
          cropper.zoom(-0.1);
        }
      },
    };

    options = setButtonsZoomToOptions(options);
    cropper = new Cropper(image, options);
  };

  const setButtonsZoomToOptions = (options) => {
    const zoomInButtonTag = document.querySelector("#zoom-in-btn");
    const zoomOutButtonTag = document.querySelector("#zoom-out-btn");
    zoomInButtonTag.onclick = options.zoom;
    zoomOutButtonTag.onclick = options.zoom;
    return options;
  };

  function cropImage() {
    const croppedCanvas = cropper.getCroppedCanvas();
    const imageContent = croppedCanvas.toDataURL();
    setImageCroppedToPreviewImageArea(imageContent);

    uploadImageAdvertiseNativeButton.setAttribute("value", imageContent);
  }

  return (
    <div>
      <span
        className="btn btn-primary"
        onClick={() => {
          document
            .querySelector("#upload-image-advertise-native-button")
            .click();
        }}
      >
        انتخاب فایل
      </span>
      <input
        type="file"
        name="image"
        accept="image/x-png,image/jpeg"
        id="upload-image-advertise-native-button"
        className="d-none"
        onChange={(e) => {
          changeHandler(e);
        }}
      />
      <Modal
        id="modal-cropper-advertise-native"
        size="lg"
        style={{ zIndex: 10000000 }}
        show={show}
        onHide={handleClose}
        backdrop="static"
        animation={true}
      >
        <Modal.Header>
          <Modal.Title>برش تصویر</Modal.Title>
        </Modal.Header>
        <Modal.Body id="modal-cropper-image-advertise-native">
          {imageTag}
        </Modal.Body>
        <Modal.Footer className="justify-content-between">
          <span>
            <Button
              className="btn btn-warning text-white"
              onClick={handleClose}
            >
              خروج
            </Button>
          </span>
          <span>
            <Button
              className="btn btn-success"
              id="btn-crop"
              onClick={() => {
                cropImage();
                handleClose();
              }}
            >
              ذخیره
            </Button>
          </span>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CropperTest;
